import { Fragment } from "react";
import { Skills } from "./UI/ContentBlocks";
import { TitleButton } from "./UI/Title";
import { Container } from "@mui/material";
import { CraftingTableContent } from "./websiteContent";
import Banner from "./UI/Banner";

const CraftingTable = () => {
  const root = CraftingTableContent;
  return (
    <Fragment>
      <Banner />
      <Container fixed>
        <div>
          <section>
            <TitleButton
              title={root.title.title}
              paragraph={root.title.paragraph}
            />
            <Skills content={root.content} />
          </section>
        </div>
      </Container>
    </Fragment>
  );
};

export default CraftingTable;
